<template>
  <Timeline class="container-operate-logs" :style="{height: height}">
    <TimelineItem v-for="item in logsOwn" :key="item.id">
      <p class="time">{{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</p>
      <p class="content"><b>操作内容：</b>{{ item.content }}</p>
      <p><b>操作用户：</b>{{ item.user.name ? item.user.name : item.user.username }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
import moment from 'moment'

export default {
  name: 'Logs',
  props: ['logs'],
  watch: {
    logs () {
      this.logsOwn = this.logs
    }
  },
  data () {
    return {
      logsOwn: this.logs,
      moment: moment,
      height: ''
    }
  },
  created () {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.height = window.innerHeight - 170 + 'px'
    }
  }
}
</script>
<style>
  .time{
    font-size: 14px;
    font-weight: bold;
  }
  .content {
    word-wrap: break-word;
  }
  .container-operate-logs {
    padding: 0;
    overflow-y: auto;
    height: auto;
    padding-bottom: 5px;
  }
  .container-operate-logs::-webkit-scrollbar {
    width: 5px;
  }
  .container-operate-logs::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .container-operate-logs::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
